import { SIGNUP_BACKEND_URL } from '@/config';
import axios from '@/lib/axios';

import { Province } from '../types';

export const getProvinces = ({ countryId }: { countryId: string }): Promise<Province[]> => {
  if (countryId) {
    return axios
      .get(SIGNUP_BACKEND_URL + 'provinces/country/' + countryId)
      .then((response: any) => {
        return response._embedded?.provinces;
      });
  }
  return new Promise((resolve) => {
    resolve([]);
  });
};
